import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import EmbedModal from './EmbedModal';

const { FiRadio, FiActivity, FiZap, FiShare2 } = FiIcons;

const Navigation = () => {
  const location = useLocation();
  const [isShareOpen, setIsShareOpen] = useState(false);
  
  const navItems = [
    { path: '/', label: 'Stream 1', icon: FiRadio, embedPath: '/embed/stream-1', size: { w: '100%', h: '450px' } },
    { path: '/stream-2', label: 'Stream 2', icon: FiActivity, embedPath: '/embed/stream-2', size: { w: '320px', h: '360px' } },
  ];

  const currentItem = navItems.find(item => 
    location.pathname === item.path || (item.path === '/' && location.pathname === '')
  ) || navItems[0];

  return (
    <>
      <nav className="fixed top-6 left-1/2 -translate-x-1/2 z-[50] flex items-center p-1.5 bg-white/90 backdrop-blur-xl border border-white shadow-2xl rounded-2xl">
        <div className="flex items-center gap-4 px-4 mr-2 border-r border-gray-100">
          <SafeIcon icon={FiZap} className="text-[#00AEEF] text-xl animate-pulse" />
          <span className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-900">Console</span>
        </div>
        
        <div className="flex gap-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path || (item.path === '/' && location.pathname === '');
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-2 px-6 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest transition-all duration-300 ${
                  isActive 
                    ? 'bg-gray-900 text-white shadow-lg' 
                    : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'
                }`}
              >
                <SafeIcon icon={item.icon} className={isActive ? 'text-[#00AEEF]' : ''} />
                {item.label}
              </Link>
            );
          })}
        </div>

        <button 
          onClick={() => setIsShareOpen(true)}
          className="ml-2 p-3 bg-[#00AEEF] text-white rounded-xl hover:bg-[#0092c9] transition-colors shadow-lg shadow-blue-100 flex items-center gap-2"
        >
          <SafeIcon icon={FiShare2} className="text-sm" />
          <span className="text-[9px] font-black uppercase tracking-widest pr-1">Embed</span>
        </button>
      </nav>

      <EmbedModal 
        isOpen={isShareOpen} 
        onClose={() => setIsShareOpen(false)} 
        embedPath={currentItem.embedPath}
        width={currentItem.size.w}
        height={currentItem.size.h}
      />
    </>
  );
};

export default Navigation;